import { onContactSupport } from '@va/dashboard/util-helpers/misc';
import { CustomerSupport, DesktopIllustration, GoBackIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button, Heading1, Paragraph, fontWeights, paragraphSizes } from '@va/ui/design-system';
import { useHistory } from 'react-router';

export const SomethingWentWrongPage = () => {
  const translate = useTranslate();
  const history = useHistory();

  return (
    <div className='flex flex-col items-center p-8 pt-16 sm-initial:pt-8!'>
      <Heading1 weight={fontWeights.semibold} className='text-center font-semibold mb-2'>
        {translate('somethingWentWrongPage.title')}
      </Heading1>
      <Paragraph size={paragraphSizes.large} className='text-center text-devil-gray'>
        {translate('somethingWentWrongPage.desc')}
      </Paragraph>
      <div className='flex gap-3 mt-6px'>
        <Button
          className='flex justify-center items-center px-6!'
          icon={() => <GoBackIcon color={'#696969'} />}
          text={translate('somethingWentWrongPage.goBack')}
          color='tertiary'
          onClick={() => history.goBack()}
        />
        <Button
          onClick={onContactSupport}
          className='flex justify-center items-center px-6!'
          icon={() => <CustomerSupport color={'#696969'} />}
          text={translate('button.contactSupport')}
          color='tertiary'
        />
      </div>
      <div className='w-full p-6 mt-3'>
        <DesktopIllustration />
      </div>
    </div>
  );
};
